import React, { useEffect } from 'react';
import Popup from 'reactjs-popup';
import WishmakerModalSC from './modal.styled';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from '../../../assets/img/svg/close-grey.svg';

const WishmakerModal = ({
  children,
  isOpened,
  onClose,
  className,
  withCross,
  closeOnDocumentClick,
}) => {
  /**
   * Add class to body to prevent scrolling
   */
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpened]);

  return (
    <WishmakerModalSC>
      <Popup
        open={isOpened}
        closeOnDocumentClick={closeOnDocumentClick}
        onClose={onClose}
        className={className ? `wishmaker-modal-${className}` : 'wishmaker-modal'}
        lockScroll
      >
        <>
          {withCross ? (
            <button onClick={onClose} className="close-button">
              <CloseIcon />
            </button>
          ) : null}
          {children}
        </>
      </Popup>
    </WishmakerModalSC>
  );
};

WishmakerModal.propTypes = {
  className: PropTypes.string,
  withCross: PropTypes.bool,
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

WishmakerModal.defaultProps = {
  className: '',
  withCross: false,
  closeOnDocumentClick: true,
};

export default WishmakerModal;
